import type { IMenuItem } from '@/shared/ui/menu.types';
import {
  getHelpCenterChapters,
  getHelpCenterRubricBySlug,
  type HelpCenterRubric as IRubric,
  type HelpCenterSection as ISection,
} from '@/shared/api/helpCenter';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useGuidesStore = defineStore('guides store', () => {
  const guidesChapters = ref<ISection[]>();
  const guidesMenu = ref<IMenuItem[]>();
  const selectedRubric = ref<IRubric>();

  const setSelectedRubric = (rubric: IRubric) => {
    selectedRubric.value = rubric;
  };

  const setGuidesChapters = (data: ISection[]) => {
    guidesChapters.value = data;
  };

  const getGuideChapters = async () => {
    try {
      const { data, error } = await getHelpCenterChapters({
        query: {
          section: 'guides',
        },
      });

      if (error || !data) {
        return;
      }

      const sections = data.results;
      sections.sort((a, b) => a.rank - b.rank);
      sections.forEach((section) => {
        section.rubrics.sort((a, b) => a.rank - b.rank);
      });

      guidesMenu.value = sections.map((section) => ({
        label: section.title,
        slug: section.slug,
        children: section.rubrics.map((rubric) => ({
          label: rubric.title,
          slug: rubric.slug,
        })),
      }));

      setGuidesChapters(sections);

      return data;
    } catch {
      return;
    }
  };

  const getRubricInfo = async (slug: string) => {
    try {
      const { data, error } = await getHelpCenterRubricBySlug({
        path: {
          slug,
        },
      });

      if (error || !data) {
        return;
      }

      setSelectedRubric(data);

      return data;
    } catch {
      return;
    }
  };

  return {
    guidesChapters,
    getGuideChapters,

    guidesMenu,

    selectedRubric,
    setSelectedRubric,
    getRubricInfo,
  };
});
